import React, { useMemo, useState } from "react";
import { faPhone, faPhoneXmark, faPhoneArrowRight } from "web-fortawesome/npm/pro-light";
import { faPhone as faPhoneSolid, faPhoneXmark as faPhoneXmarkSolid, faPhoneArrowRight as faPhoneArrowRightSolid } from "web-fortawesome/npm/pro-solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IPresenceIconProps } from "./IPresenceIconProps";

/**
 * Presence Icon: Phone
 * @param props - props from interface IPresenceIconProps
 * @returns - the phone icon
 */
export const PresenceIconPhone = (props: IPresenceIconProps): React.ReactElement => {
	const icon = useMemo(() => {
		if (!props.callProtection && !props.lineForwarded) {
			if (props.type === "busy")
				return faPhoneSolid;
			else
				return faPhone;
		} else if (props.callProtection) {
			if (props.type === "busy")
				return faPhoneXmarkSolid;
			else
				return faPhoneXmark;
		} else if (props.lineForwarded) {
			if (props.type === "busy")
				return faPhoneArrowRightSolid;
			else
				return faPhoneArrowRight;
		}
		return faPhone;
	}, [props.type, props.callProtection, props.lineForwarded]);

	return (
		<FontAwesomeIcon
			className={props.className}
			icon={icon}
			fontSize={props.fontSize ?? 16}
			color={props.color ? props.color : `var(--presence-icon-type-${props.type ?? "free"})`}
		/>
	);
};
